<template>
  <div>
    <header-section :title='"Về Mora"'></header-section>
    <vision-core-val></vision-core-val>
    <philosophy-mora></philosophy-mora>
    <introduce></introduce>
    <mora-team></mora-team>
  </div>
</template>
<script>
  import Introduce from "./components/AboutMora/Introduce.vue";
  import MoraTeam from "./components/AboutMora/MoraTeam.vue";
  import HeaderSection from "./components/Common/HeaderSection.vue";
  import VisionCoreVal from "./components/AboutMora/VisionAndCoreValue.vue";
  import PhilosophyMora from "./components/AboutMora/PhilosophyMora.vue"
  export default{
    components:{
      Introduce,
      MoraTeam,
      HeaderSection,
      VisionCoreVal,
      PhilosophyMora
    }
  };
</script>


// WEBPACK FOOTER //
// src/views/AboutMora.vue